<div class="gp-toast" [ngClass]="'gp-toast--' + config.key">
  <i class="gp-toast__icon" [ngClass]="config.icon" aria-hidden="true"></i>
  <div class="gp-toast__content">
    <div *ngIf="toastPackage.title" class="gp-toast__title">{{ toastPackage.title }}</div>
    <div *ngIf="toastPackage.message"
         class="gp-toast__message"
         [innerHTML]="toastPackage.message">
    </div>
  </div>
  <button type="button" class="gp-toast__close" (click)="close($event)" aria-label="Close">
    <i class="fa-solid fa-xmark" aria-hidden="true"></i>
  </button>
</div>

